import { DefaultForm } from "./DefaultForm";

export class AccessForm extends DefaultForm {
	constructor(form) {
		super();
		this.$form = form;
		this.sphereChanged = false;
	}

	init() {
		$(this.$form).on("afterValidate", (event, messages, errorAttributes) => {
			this.errors = [];
			const dropdown = this.$form.querySelector(".dropdown");
			if (dropdown && dropdown.classList.contains("dropdown_sphere")) {
				this.sphereChanged = true;
			}
			if (messages) {
				Object.keys(messages).forEach(key => {
					const keyLast = key.split("-")[1];
					if (messages.errors) {
						Object.keys(messages.errors).forEach(error => {
							if (error === keyLast) {
								this.errors.push(key);
							}
						});
					} else {
						if (messages[key].length) {
							this.errors.push(key);
						}
					}
				});
			}
			this.checkFields(this.$form);
		});

		$(window).on("ariaDropdown.slideUp", (event, dropdown) => {
			const $currentForm = dropdown.element.parents("form");

			if ($currentForm[0]) {
				setTimeout(() => {
					this.checkFields($currentForm[0]);
				}, 200);
			}
		});
	}

	checkFields($form) {
		const $submitButton = $form.querySelector(".js-form-submit-button");
		const $fields = $form.querySelectorAll(".js-required-field");
		const isValid = this.checkSphere() && this.checkInputs($fields);

		isValid
			? this.activateSubmitButton($submitButton)
			: this.disableSubmitButton($submitButton);
	}

	checkSphere() {
		const button = document.querySelector("#js-dropdown-sphere .required-sign");

		if (button && this.sphereChanged) {
			const buttonInitialText = button.dataset.initial.trim();
			const buttonCurrentText = button.textContent.trim();
			return !(buttonInitialText === buttonCurrentText);
		}
		return true;
	}
}
